export function generateBillPayLink(paymentUrl: string) {
    const portalUrl = paymentUrl.split("/p/")[0]!;
    return `<a href="${paymentUrl}" style="display:inline-block; height: 48px; vertical-align: middle; width: 156px;" target="_blank"><img style="max-height: 100%; max-width: 100%;" src="${portalUrl}/make_a_payment.png" alt="Make a Payment"></a>`;
}
